module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    staticClass: "request",
    attrs: {
      "grid": true,
      "inner": true
    }
  }, [_c('FormInput', {
    staticClass: "request__item",
    attrs: {
      "label": "Название запроса",
      "placeholder": "Напишите название запроса",
      "error-text": "Необходимо заполнить поле корректно",
      "maxlength": "255",
      "v": _vm.v.title,
      "bigLabel": true,
      "required": true
    },
    model: {
      value: (_vm.resultForm.title),
      callback: function($$v) {
        _vm.$set(_vm.resultForm, "title", $$v)
      },
      expression: "resultForm.title"
    }
  }), _c('Textarea', {
    staticClass: "request__item",
    attrs: {
      "label": "Запрос",
      "error-text": "Текст превышает допустимое количество символов.",
      "v": _vm.v.text,
      "bigLabel": true,
      "required": true,
      "description": _vm.description
    },
    model: {
      value: (_vm.resultForm.text),
      callback: function($$v) {
        _vm.$set(_vm.resultForm, "text", $$v)
      },
      expression: "resultForm.text"
    }
  }), _c('h3', {
    staticClass: "request__part"
  }, [_vm._v("Предпочтения в отношении наставника")]), _c('Select', {
    attrs: {
      "name": "level_id",
      "placeholder": "Мужчина или женщина",
      "error-text": "Необходимо выбрать пол",
      "options": _vm.genderSelect,
      "v": _vm.v.gender
    },
    model: {
      value: (_vm.resultForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.resultForm, "gender", $$v)
      },
      expression: "resultForm.gender"
    }
  }), _c('Select', {
    attrs: {
      "name": "level_id",
      "placeholder": "Учитель",
      "error-text": "Необходимо выбрать учителя",
      "options": _vm.mentoringTypes,
      "v": _vm.v.mentor
    },
    model: {
      value: (_vm.resultForm.mentor),
      callback: function($$v) {
        _vm.$set(_vm.resultForm, "mentor", $$v)
      },
      expression: "resultForm.mentor"
    }
  }), _c('div', {
    staticClass: "request__age"
  }, [_c('span', {
    staticClass: "request__label"
  }, [_vm._v("Возраст наставника"), _c('sup', [_vm._v("*")])]), _c('div', {
    staticClass: "request__field"
  }, [_c('span', {
    staticClass: "request__dot"
  }, [_vm._v("от")]), _c('FormInput', {
    attrs: {
      "error-text": "Не меньше 10 лет",
      "v": _vm.v.ageFrom
    },
    model: {
      value: (_vm.resultForm.ageFrom),
      callback: function($$v) {
        _vm.$set(_vm.resultForm, "ageFrom", $$v)
      },
      expression: "resultForm.ageFrom"
    }
  })], 1), _c('div', {
    staticClass: "request__field"
  }, [_c('span', {
    staticClass: "request__dot"
  }, [_vm._v("до")]), _c('FormInput', {
    attrs: {
      "error-text": "Введите большее число",
      "v": _vm.v.ageTo
    },
    model: {
      value: (_vm.resultForm.ageTo),
      callback: function($$v) {
        _vm.$set(_vm.resultForm, "ageTo", $$v)
      },
      expression: "resultForm.ageTo"
    }
  })], 1)]), _c('FormInput', {
    attrs: {
      "label": "Предпочтительное время встреч",
      "placeholder": "Напишите время встреч",
      "error-text": "Необходимо заполнить поле корректно",
      "maxlength": "255",
      "required": true,
      "v": _vm.v.time
    },
    model: {
      value: (_vm.resultForm.time),
      callback: function($$v) {
        _vm.$set(_vm.resultForm, "time", $$v)
      },
      expression: "resultForm.time"
    }
  }), _c('Button', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.submitRequestForm
    }
  }, [_vm._v("Опубликовать")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48aa25fa","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/requestform/MentoringNewRequestForm.vue
// module id = 8523c4b2d82af22c3279
// module chunks = 89